/** Default clamp forecast expected arrival: 60 calendar days after plan month end. */
export const CLAMP_FORECAST_EXPECTED_ARRIVAL_DAYS_AFTER_MONTH_END = 60;

/**
 * Plan month is YYYY-MM-01. Returns YYYY-MM-DD for 60 days after the last day
 * of that month (UTC calendar math). Prefills the callout date field for new
 * forecast cells only; grid arrival math uses explicit saved cell or PO dates.
 */
export function defaultClampForecastExpectedArrivalDate(planMonthIso: string): string {
  const trimmed = planMonthIso.trim();
  if (!/^\d{4}-\d{2}-01$/.test(trimmed)) {
    return trimmed;
  }
  const year = Number.parseInt(trimmed.slice(0, 4), 10);
  const month = Number.parseInt(trimmed.slice(5, 7), 10);
  if (!Number.isFinite(year) || !Number.isFinite(month) || month < 1 || month > 12) {
    return trimmed;
  }
  const endOfMonthUtc = Date.UTC(year, month, 0);
  const arrivalUtc =
    endOfMonthUtc + CLAMP_FORECAST_EXPECTED_ARRIVAL_DAYS_AFTER_MONTH_END * 24 * 60 * 60 * 1000;
  const arrival = new Date(arrivalUtc);
  const arrivalYear = arrival.getUTCFullYear();
  const arrivalMonth = String(arrival.getUTCMonth() + 1).padStart(2, "0");
  const arrivalDay = String(arrival.getUTCDate()).padStart(2, "0");
  return `${arrivalYear}-${arrivalMonth}-${arrivalDay}`;
}
